var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostGraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1534 0.646821L9.66291 8.93022C9.4871 9.10175 9.37436 9.32076 9.34949 9.53908C9.32463 9.7574 9.38968 9.95714 9.53033 10.0944C9.67098 10.2316 9.87572 10.295 10.0995 10.2708C10.3233 10.2465 10.5478 10.1365 10.7236 9.96501L19.2141 1.68161C19.3899 1.51008 19.5026 1.29107 19.5275 1.07275C19.5523 0.854435 19.4873 0.654695 19.3466 0.517474C19.206 0.380252 19.0013 0.316789 18.7775 0.341046C18.5537 0.365304 18.3292 0.475294 18.1534 0.646821Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1534 6.50407L0.662913 11.8606C0.487097 12.0322 0.374357 12.2512 0.349493 12.4695C0.324629 12.6878 0.389678 12.8876 0.53033 13.0248C0.670982 13.162 0.875716 13.2255 1.09949 13.2012C1.32327 13.1769 1.54776 13.067 1.72357 12.8954L7.21406 7.53886C7.38987 7.36733 7.50261 7.14832 7.52748 6.93C7.55234 6.71168 7.48729 6.51194 7.34664 6.37472C7.20599 6.2375 7.00125 6.17404 6.77748 6.1983C6.5537 6.22255 6.32921 6.33254 6.1534 6.50407Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2139 8.93013L7.72346 6.50038C7.54764 6.32885 7.32316 6.21886 7.09938 6.19461C6.8756 6.17035 6.67087 6.23381 6.53022 6.37103C6.38956 6.50825 6.32452 6.70799 6.34938 6.92631C6.37424 7.14463 6.48698 7.36364 6.6628 7.53517L9.15329 9.96492C9.3291 10.1364 9.55359 10.2464 9.77737 10.2707C10.0011 10.2949 10.2059 10.2315 10.3465 10.0943C10.4872 9.95704 10.5522 9.7573 10.5274 9.53898C10.5025 9.32066 10.3898 9.10165 10.2139 8.93013Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.2683C0 18.8642 0.319561 18.5366 0.71376 18.5366H19.2862C19.6804 18.5366 20 18.8642 20 19.2683C20 19.6724 19.6804 20 19.2862 20H0.71376C0.319561 20 0 19.6724 0 19.2683Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7138 0C13.3196 0 13 0.327597 13 0.731707C13 1.13582 13.3196 1.46341 13.7138 1.46341H18.5L18.5 6.13292C18.5 6.5175 18.8358 6.82927 19.25 6.82927C19.6642 6.82927 20 6.5175 20 6.13292L20 0.731776C20 0.731753 20 0.73173 20 0.731707V0.696352C20 0.506627 19.9183 0.334623 19.7857 0.20903C19.657 0.0797244 19.4807 0 19.2862 0H19.25H13.7138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostGraph);
export default __webpack_public_path__ + "static/media/post_graph.69916d0e6ba1090f7634623cfb5369d2.svg";
export { ForwardRef as ReactComponent };